var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1B2E4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61838 19.5744V9.2461H4.1885V19.5744H7.61874H7.61838ZM5.90416 7.83619C7.09998 7.83619 7.84446 7.0431 7.84446 6.05195C7.82207 5.03823 7.09998 4.26727 5.9269 4.26727C4.75301 4.26727 3.98633 5.03823 3.98633 6.05186C3.98633 7.04301 4.73054 7.8361 5.88168 7.8361H5.90389L5.90416 7.83619ZM9.51687 19.5744H12.9465V13.8072C12.9465 13.499 12.9689 13.1899 13.0595 12.9697C13.3073 12.3527 13.8717 11.714 14.8194 11.714C16.0601 11.714 16.5568 12.6611 16.5568 14.0496V19.5744H19.9863V13.6525C19.9863 10.4802 18.2945 9.00396 16.0379 9.00396C14.1879 9.00396 13.3754 10.0389 12.9239 10.7438H12.9468V9.24646H9.51705C9.56182 10.2154 9.51678 19.5748 9.51678 19.5748L9.51687 19.5744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.29062aad85618efb7d7f0e3154f3d3a6.svg";
export { ForwardRef as ReactComponent };